import type { JSX, ReactNode } from 'react';
import { Children, isValidElement } from 'react';
import { fieldAnim } from './keyframes.js';
import { STAGGER_CAP, STAGGER_MS } from './tokens.js';

interface StaggerProps {
  gap?: number;
  cap?: number;
  children: ReactNode;
}

// Wraps each child in a div with a computed animation-delay so they fade
// and slide in one after another. Cap prevents a 20-question page from
// taking 1+ seconds to settle (5 × 50 ms = 250 ms ceiling by default).
//
// Why a wrapper div instead of cloning each child's style: the wrapper
// lets us animate without forcing every consumer to forward refs and
// merge styles. flex/grid parents treat the wrapper as a normal item.
export function Stagger({ gap = STAGGER_MS, cap = STAGGER_CAP, children }: StaggerProps): JSX.Element {
  const items = Children.toArray(children);
  return (
    <>
      {items.map((child, i) => {
        const delay = Math.min(i, cap) * gap;
        const key = (isValidElement(child) && child.key) || i;
        return (
          <div key={key} style={{ animation: fieldAnim(delay) }}>
            {child}
          </div>
        );
      })}
    </>
  );
}
